var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-16px col-lg-6"},[_c('i',{staticClass:"tio-add-circle color-yellow"}),_vm._v(" Aggiungi eventuale altra documentazione\n")])
}]

export { render, staticRenderFns }